"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FONT_TYPES = void 0;
var FONT_TYPES = Object.freeze({
  h0: 'h0',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  bodyHeading: 'bodyHeading',
  body: 'body',
  bodySmallHeading: 'bodySmallHeading',
  bodySmall: 'bodySmall',
  finePrintHeading: 'finePrintHeading',
  finePrint: 'finePrint',
  legal: 'legal'
});
exports.FONT_TYPES = FONT_TYPES;